import { ResponsesElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class Responses extends ResponsesElement {}
export default Responses;